import styled from 'styled-components';
import { theme } from '../../../styles/theme';

export const Section = styled.section`
  padding: 6rem 8%;
  background: ${theme.colors.bgLight};
`;

export const Header = styled.div`
  text-align: center;
`;

export const SectionTag = styled.span`
  display: inline-block;
  color: ${theme.colors.orange};
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  margin-bottom: 0.75rem;
`;

export const SectionTitle = styled.h2`
  font-family: ${theme.fonts.display};
  font-size: clamp(2rem, 3.5vw, 2.9rem);
  font-weight: 800;
  line-height: 1.05;
  letter-spacing: -0.03em;
  color: ${theme.colors.black};
  margin-bottom: 1rem;
`;

export const SectionSub = styled.p`
  color: ${theme.colors.mid};
  font-size: 1rem;
  line-height: 1.7;
  max-width: 540px;
  font-weight: 400;
  margin-left: auto;
  margin-right: auto;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;
  margin-top: 3.5rem;

  @media (max-width: 960px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const Card = styled.div`
  background: white;
  border-radius: 20px;
  padding: 1.8rem;
  border: 1px solid ${theme.colors.border};
  transition: transform 0.3s, box-shadow 0.3s;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
  }
`;

export const Stars = styled.div`
  color: ${theme.colors.orange};
  letter-spacing: 2px;
  font-size: 0.85rem;
  margin-bottom: 1rem;
`;

export const Quote = styled.blockquote`
  color: ${theme.colors.dark};
  font-size: 0.9rem;
  line-height: 1.7;
  font-style: italic;
  margin-bottom: 1.5rem;
`;

export const Author = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
`;

export const AuthorAv = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: linear-gradient(135deg, ${theme.colors.orange}, #ffa07a);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 0.8rem;
  color: white;
  flex-shrink: 0;
`;

export const AuthorInfo = styled.div`
  strong {
    display: block;
    font-weight: 600;
    font-size: 0.83rem;
    color: ${theme.colors.black};
  }
  span {
    font-size: 0.75rem;
    color: ${theme.colors.mid};
  }
`;
